import React, { useRef, useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Navbar from "./components/Navbar";
import FrontPage from "./components/FrontPage";
import Footer from "./components/Footer";
import OurTeam from "./components/pages/OurTeam";
import AboutUs from "./components/pages/AboutUs";
import ContactUs from "./components/pages/ContactUs";
import MoneyTransfer from "./components/pages/MoneyTransfer";
import FrequentlyAskedQs from "./components/pages/FrequentlyAskedQs";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermsAndConditions from "./components/pages/TermsAndConditions";
import ServicePolicy from "./components/pages/ServicePolicy";
import ComplaintsProcedures from "./components/pages/ComplaintsProcedures";
import CookiePolicy from "./components/pages/CookiePolicy";
import SignUp from "./components/SignUp";
import Login from "./components/Login";
import Admin from "./components/pages/Admin";
import NotFound from "./components/pages/NotFound";
import ForgotPassword from "./components/pages/ForgotPassword";

function App(props) {
  const homeRef = useRef(null);
  const sendRef = useRef(null);
  const howRef = useRef(null);
  const contactRef = useRef(null);

  const [stickyNavbar, setStickyNavbar] = useState(false);

  const handleScroll = () => {
    let elementBounds = homeRef.current;
    if (elementBounds) {
      let { top } = elementBounds.getBoundingClientRect();
      if (top < -80) {
        setStickyNavbar(true);
      } else {
        setStickyNavbar(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <Navbar
        homeRef={homeRef}
        sendRef={sendRef}
        howRef={howRef}
        contactRef={contactRef}
        stickyNavbar={stickyNavbar}
      />
      <Switch>
        <Route
          exact
          path="/our-team"
          render={(props) => (
            <OurTeam {...props} homeRef={homeRef} handleScroll={handleScroll} />
          )}
        />
        <Route
          exact
          path="/about-us"
          render={(props) => (
            <AboutUs {...props} homeRef={homeRef} handleScroll={handleScroll} />
          )}
        />
        <Route
          exact
          path="/contact-us"
          render={(props) => (
            <ContactUs
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          exact
          path="/money-transfer"
          render={(props) => (
            <MoneyTransfer
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          exact
          path="/faqs"
          render={(props) => (
            <FrequentlyAskedQs
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          exact
          path="/privacy-policy"
          render={(props) => (
            <PrivacyPolicy
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          exact
          path="/terms"
          render={(props) => (
            <TermsAndConditions
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          exact
          path="/tml-policy"
          render={(props) => (
            <ServicePolicy
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          exact
          path="/complaints"
          render={(props) => (
            <ComplaintsProcedures
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          exact
          path="/cookies"
          render={(props) => (
            <CookiePolicy
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          exact
          path="/login"
          render={(props) => (
            <Login {...props} homeRef={homeRef} handleScroll={handleScroll} />
          )}
        />
        <Route
          exact
          path="/sign-up"
          render={(props) => (
            <SignUp {...props} homeRef={homeRef} handleScroll={handleScroll} />
          )}
        />
        <Route
          exact
          path="/forgot-password"
          render={(props) => (
            <ForgotPassword
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          exact
          path="/admin"
          render={(props) => (
            <Admin {...props} homeRef={homeRef} handleScroll={handleScroll} />
          )}
        />
        <Route
          exact
          path="/"
          render={(props) => (
            <FrontPage
              {...props}
              homeRef={homeRef}
              sendRef={sendRef}
              howRef={howRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Route
          to="/not-found"
          render={(props) => (
            <NotFound
              {...props}
              homeRef={homeRef}
              handleScroll={handleScroll}
            />
          )}
        />
        <Redirect to="/not-found" />
      </Switch>

      <Footer contactRef={contactRef} />
    </div>
  );
}

export default App;
